"use strict";

exports.__esModule = true;
exports.filterPageLevelTags = filterPageLevelTags;

var _identify = require("../../renderer/utils/identify");

var _Identifiers = require("../../types/Identifiers");

var _safelyParseJsonData = require("../../renderer/utils/safely-parse-json-data");

var BLACK_LIST = [_Identifiers.IDENTIFIERS.DESCRIPTION];

function filterPageLevelTags(advancedSeoData) {
  if (typeof advancedSeoData === 'string') {
    advancedSeoData = (0, _safelyParseJsonData.safelyParseJsonData)(advancedSeoData);
  }

  advancedSeoData.tags = advancedSeoData.tags.filter(function (tag) {
    var identifier = (0, _identify.identify)(tag);
    return !BLACK_LIST.some(function (i) {
      return identifier === i;
    });
  });
  return advancedSeoData;
}